<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import NavBar from '@/components/layout/NavBar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import { buildStartlineOrganizerTermsHtml } from '@/utils/startlineOrganizerTermsContent'
import { useAppConfig } from '@/composables/useAppConfig'
import { FALLBACK_COMPANY } from '@/constants/company'

const { t } = useI18n()
const { config } = useAppConfig()
const organizerTermsHtml = computed(() =>
  buildStartlineOrganizerTermsHtml(
    config.value?.email ?? { info: 'info@startline.be' },
    config.value?.company ?? FALLBACK_COMPANY,
  ),
)
</script>

<template>
  <div class="flex flex-col min-h-screen bg-slate-900">
    <NavBar />
    <main class="flex-1 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
      <h1 class="text-3xl font-bold text-white mb-6">{{ t('legal.terms_organizers.heading') }}</h1>
      <div class="legal-content" v-html="organizerTermsHtml" />
    </main>
    <AppFooter />
  </div>
</template>

<style scoped>
@reference "tailwindcss";

.legal-content :deep(h2) {
  @apply text-xl font-semibold text-white mt-10 mb-4;
}
.legal-content :deep(h3) {
  @apply text-base font-semibold text-slate-200 mt-6 mb-2;
}
.legal-content :deep(p) {
  @apply text-slate-300 mb-4 leading-relaxed;
}
.legal-content :deep(ul) {
  @apply list-disc list-inside text-slate-300 mb-4 space-y-1;
}
.legal-content :deep(table) {
  @apply w-full text-sm text-slate-300 mb-6 border-collapse;
}
.legal-content :deep(th) {
  @apply text-left font-semibold text-slate-200 border-b border-slate-600 pb-2 pr-4;
}
.legal-content :deep(td) {
  @apply border-b border-slate-700 py-2 pr-4 align-top;
}
.legal-content :deep(strong) {
  @apply text-slate-100 font-semibold;
}
.legal-content :deep(a) {
  @apply text-emerald-400 hover:text-emerald-300;
}
</style>
